import { ROUTE_NAME } from '@constants';

const useInformation = {
  path: '/use-information',
  redirect: '/use-information/guide',
  name: ROUTE_NAME.UseInformation,
  meta: {
    breadcrumb: true,
    breadcrumbName: '이용안내',
  },
  children: [
    {
      name: ROUTE_NAME.Guide,
      path: 'guide',
      component: () => import('@views/use-information/Guide.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '이용방법',
      },
    },
    {
      name: ROUTE_NAME.FeeInformation,
      path: 'fee',
      alias: 'fee',
      component: () => import('@views/use-information/Fee.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '요금안내',
      },
    },
  ],
};
export default useInformation;
